export default {
  name: 'tenant',
  tenant: 'tenant',
  enableFeatures: 'enableFeatures'
};
